/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput';

export class RestoreEc2InstanceConfig {
  /**
  * The instance type to use for the output instance
  */
  'instanceType'?: string;
  /**
  * The subnet ID to deploy the output instance to
  */
  'subnetId'?: string;
  /**
  * Optional security group IDs to apply to the output instance
  */
  'securityGroupIds'?: Array<string>;
  /**
  * Optional instance profile name to apply to the output instance
  */
  'instanceProfileName'?: string;
  /**
  * Optional tags to apply to the output instance
  */
  'tags'?: { [key: string]: string; };
  'volumeRestoreParameters'?: Array<RestoreInstanceVolumeInput>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceType",
      "baseName": "instanceType",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetId",
      "baseName": "subnetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "instanceProfileName",
      "baseName": "instanceProfileName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "volumeRestoreParameters",
      "baseName": "volumeRestoreParameters",
      "type": "Array<RestoreInstanceVolumeInput>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreEc2InstanceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

